module.exports = __webpack_public_path__ + "static/media/jobDetailsIcon.71ef6c57.svg";